// extracted by mini-css-extract-plugin
export default {"TopHeader":"TopHeader_TopHeader__05hZY"};